module.exports = __webpack_public_path__ + "img/icon_tag101.dbb0362c.svg";